module.exports = __webpack_public_path__ + "img/20220622111217.3e813c9a.png";